import { GridCellProps, GridColumnProps, GridFilterCellProps } from '@progress/kendo-react-grid'

import { PlatformConfigurationKey } from '../../../../api/Trading-Accounts/Types/PlatformConfigurationTypesDto'
import { CheckboxFilterCell, selectFilterCell } from '../../../../components/Filter/FilterCell'
import { useAppSelector } from '../../../../store'

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

const TickmillCompaniesFilterCell: React.FC<GridFilterCellProps> = (props) => {
  const tickmillCompanies = useAppSelector((state) => state.identity.tickmillCompanies)

  return selectFilterCell({
    items: tickmillCompanies.map((x) => ({
      id: x.id.toString(),
      value: x.id.toString(),
      label: x.name,
    })),
    options: {
      operator: '==',
    },
  })(props)
}

const PlatformTypesFilterCell: React.FC<GridFilterCellProps> = (props) => {
  const platformTypes = useAppSelector((state) => state.tradingAccounts.platformTypes)

  return selectFilterCell({
    items: platformTypes.map((x) => ({
      id: x.id.toString(),
      value: x.id.toString(),
      label: x.name,
    })),
    options: {
      operator: '==',
    },
  })(props)
}

const PlatformServersFilterCell: React.FC<GridFilterCellProps> = (props) => {
  const platformServers = useAppSelector((state) => state.tradingAccounts.allServers)

  return selectFilterCell({
    items: platformServers.map((x) => ({
      id: x.id.toString(),
      value: x.id.toString(),
      label: x.publicName,
    })),
    options: {
      operator: '==',
    },
  })(props)
}

const brokeragePlatformConfigurationColumn: GridColumn[] = [
  {
    title: 'Company',
    field: PlatformConfigurationKey.companyId,
    filterCell: TickmillCompaniesFilterCell,
    cell: (props: GridCellProps): JSX.Element => {
      if (!props.dataItem.tickmillCompany?.name) {
        return <td />
      }
      return <td>{props.dataItem.tickmillCompany?.name}</td>
    },
    show: true,
  },
  {
    title: 'Platform Type',
    field: PlatformConfigurationKey.platformTypeId,
    filterCell: PlatformTypesFilterCell,
    cell: (props: GridCellProps): JSX.Element => {
      if (!props.dataItem.platformType?.name) {
        return <td />
      }
      return <td>{props.dataItem.platformType?.name}</td>
    },
    show: true,
  },
  {
    title: 'Live Server',
    field: PlatformConfigurationKey.liveServerId,
    filterCell: PlatformServersFilterCell,
    cell: (props: GridCellProps): JSX.Element => {
      if (!props.dataItem.server?.publicName) {
        return <td />
      }
      return <td>{props.dataItem.server?.publicName}</td>
    },
    show: true,
  },
  {
    title: 'Demo Server',
    field: PlatformConfigurationKey.demoServerId,
    filterCell: PlatformServersFilterCell,
    cell: (props: GridCellProps): JSX.Element => {
      if (!props.dataItem.demoServer?.publicName) {
        return <td />
      }
      return <td>{props.dataItem.demoServer?.publicName}</td>
    },
    show: true,
  },
  {
    title: 'Welcome Server',
    field: PlatformConfigurationKey.welcomeServerId,
    filterCell: PlatformServersFilterCell,
    cell: (props: GridCellProps): JSX.Element => {
      if (!props.dataItem.welcomeServer?.publicName) {
        return <td />
      }
      return <td>{props.dataItem.welcomeServer?.publicName}</td>
    },
    show: true,
  },
  {
    title: 'Mam Server',
    field: PlatformConfigurationKey.mamServerId,
    filterCell: PlatformServersFilterCell,
    cell: (props: GridCellProps): JSX.Element => {
      if (!props.dataItem.mamServer?.publicName) {
        return <td />
      }
      return <td>{props.dataItem.mamServer?.publicName}</td>
    },
    show: true,
  },
  {
    title: 'Dynamic Leverage',
    field: PlatformConfigurationKey.dynamicLeverage,
    filterCell: CheckboxFilterCell,
    show: true,
  },
]

export default brokeragePlatformConfigurationColumn
